import moment from "moment";
import UploadDoc from "../assets/UploadDoc";

export const getInitials = (name) => {
 if (typeof name !== "string" || !name.trim()) return null;

  const nameParts = name.trim().split(" ");
  if (nameParts) {
    const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
    return initials.toUpperCase();
  } else {
    return nameParts[0][0].toUpperCase();
  }
};

export const formatDate = (date, format = "DD-MM-YYYY hh:mm A") => {
  if (!date || !moment(date).isValid()) return null;
  return moment(date).format(format);
};

/** Use for IB hierarchy limits; avoids treating API string "false" as restricted (truthy). */
export const isIbRestrictedHierarchy = (userDetails) => {
  const v = userDetails?.isRestrictedHierarchy;
  return v === true || v === 'true' || v === 1 || v === '1';
};

export const mobileNumberValidator = (t) => ({
  validator(_, value) {
    if (!value) {
      return Promise.reject(t ? t("Phone number required") : "Phone number required");
    }
    if (!/^\d+$/.test(value)) {
      return Promise.reject(t ? t("Only numbers are allowed") : "Only numbers are allowed");
    }
    if (value.length < 8 || value.length > 15) {
      return Promise.reject(t ? t("Mobile number must be between 8 and 15 digits") : "Mobile number must be between 8 and 15 digits");
    }
    return Promise.resolve();
  },
});

export const AlternativeMobileNumberValidator = (t) => ({
  validator(_, value) {
    if (!value) return Promise.resolve();
    if (!/^\d+$/.test(value)) {
      return Promise.reject(t ? t("Only numbers are allowed") : "Only numbers are allowed");
    }
    if (value.length < 8 || value.length > 15) {
      return Promise.reject(t ? t("Mobile number must be between 8 and 15 digits") : "Mobile number must be between 8 and 15 digits");
    }
    return Promise.resolve();
  },
});

export const DocumentUploadButton = (
  <div className="flex justify-center flex-col items-center md:py-4 md:px-5">
    <div className="flex justify-center w-auto mb-5 px-4 py-4 bg-gray-100 rounded-md pointer-events-none opacity-75">
      <UploadDoc color="#7367F0" />
    </div>
    <div className="text-base font-medium capitalize mb-1 pointer-events-none text-gray-500">
      Upload Company Document
    </div>
    <div className="text-gray-400">
      Drag and drop your files here or{" "}
      <span className="text-[#7367F0] cursor-pointer">Click to Select</span>
    </div>
    <div className="text-gray-400">
      Supported Formats: .jpg, .jpeg, .png, .pdf, .doc, .docx
    </div>
  </div>
);
